import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute, Params} from '@angular/router';

import * as fromApp from '../../../store/app.reducers';
import * as fromCertificate from '../store/certificate.reducers';
import * as CertificateActions from '../store/certificate.actions';


@Component({
    selector: 'app-certificate-waiting',
    templateUrl: './certificate-waiting.component.html',
    styleUrls: ['./certificate-waiting.component.scss'],
    standalone: false
})
export class CertificateWaitingComponent implements OnInit, OnDestroy {

  certificateState: Observable<fromCertificate.State>;
  routeSubscription: Subscription;
  id: number;

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.certificateState = this.store.select('certificate');
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        this.id = +params.id;
        this.store.dispatch(
          new CertificateActions.GetCertificateProfile({
            id: this.id,
            redirect: true
          })
        );
      }
    );
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

}
